<section class="mu-home" *ngIf="createQueryForm && !showImport && !showUpdateImport">
  <div class="container">
    <div class="row">
      <div class="col-lg-12 offset-lg-0 col-md-11 offset-md-1 col-12">
        <div class="col-12">
          <div class="row">
            <div class="col-md-12 text-end">
              <a><button type="button" class="btn-actvtytp" (click)="showImport = !showImport">BULK IMPORT</button></a>
              <a class="ms-2">
                <button type="button" class="btn-actvtytp" (click)="showUpdateImport = !showUpdateImport">
                  BULK UPDATE
                </button>
              </a>
            </div>
            <div class="col-md-12 mb-2 empl-tptxt">
              <h3>New Query</h3>
            </div>
            <div class="col-12 col-md-6">
              <form [formGroup]="createQueryForm">
                <div class="row">
                  <div class="col-12 col-md-12">
                    <app-category-selector
                      [module]="module"
                      (categorySelectorEvent)="onCategorySelected($event)"></app-category-selector>
                  </div>
                  <div class="col-12">
                    <div class="mb-3">
                      <label for="queryName" class="form-label">Query Name <sup>*</sup></label>
                      <input
                        type="text"
                        placeholder="Search Query Name"
                        [formControlName]="titleControlName"
                        [matAutocomplete]="auto"
                        class="form-control"
                        [ngClass]="{ 'is-invalid': f['title'].errors && f['title'].touched }" />
                      <mat-autocomplete #auto="matAutocomplete">
                        <mat-option
                          *ngFor="let queryTaskType of filteredTaskTypes | async"
                          [value]="queryTaskType.label">
                          {{ queryTaskType.label }}
                        </mat-option>
                      </mat-autocomplete>
                      <app-validation
                        field="title"
                        [form]="createQueryForm"
                        [error]="{ required: 'This is a mandatory field, Kindly select Query Name' }"></app-validation>
                    </div>
                  </div>
                  <div class="col-12">
                    <div class="mb-3">
                      <label for="exampleFormControlTextarea1" class="form-label">Description <sup>*</sup></label>
                      <textarea
                        class="form-control"
                        id="exampleFormControlTextarea1"
                        rows="4"
                        formControlName="description"
                        [ngClass]="{ 'is-invalid': f['description'].errors && f['description'].touched }"></textarea>
                      <app-validation
                        field="description"
                        [form]="createQueryForm"
                        [error]="{
                          required: 'This is a mandatory field, Kindly add description',
                          minLength: 'Description should have minimum 5 characters.',
                          maxLength: 'Max 5000 characters allowed'
                        }"></app-validation>
                    </div>
                  </div>
                  <div
                    class="col-12 col-md-6"
                    *ngIf="createQueryForm && createQueryForm.controls[OWNER_ID_CONTROL_NAME]">
                    <app-employee-selector
                      (selectedValueChange)="handleEmployeeSelectedValue($event)"
                      (selectedEmployee)="handleEmployeeSelected($event)"></app-employee-selector>
                    <app-validation
                      [field]="OWNER_ID_CONTROL_NAME"
                      [form]="createQueryForm"
                      [error]="{
                        required: 'This is a mandatory field, Kindly select Valid Employee'
                      }"></app-validation>
                  </div>
                  <div class="col-12 col-md-6">
                    <div class="mb-3">
                      <label for="exampleFormControlInput1" class="form-label">Response Due by <sup>*</sup></label>
                      <input
                        type="date"
                        class="form-control"
                        onFocus="this.showPicker()"
                        [formControlName]="RESPONSE_DUE_DATE_TIME_CONTROL_NAME"
                        [ngClass]="{
                          'is-invalid':
                            f[RESPONSE_DUE_DATE_TIME_CONTROL_NAME].errors &&
                            f[RESPONSE_DUE_DATE_TIME_CONTROL_NAME].touched
                        }" />
                      <app-validation
                        [field]="RESPONSE_DUE_DATE_TIME_CONTROL_NAME"
                        [form]="createQueryForm"
                        [error]="{
                          required: 'This is a mandatory field, Kindly select select Response Due By Date'
                        }"></app-validation>
                    </div>
                  </div>
                  <!--<div class="col-12 col-md-6">
                    <div class="mb-3">
                      <app-company-selector
                        (selectedValueChange)="handleCompanySelectedValue($event)"></app-company-selector>
                    </div>
                  </div>-->
                </div>
              </form>
            </div>
            <div class="col-12 col-md-6">
              <p>Upload Documents</p>
              <app-multiple-file-selector
                [maxAllowedSizeInMB]="2"
                [allowedTypes]="[
                  'application/pdf',
                  'image/jpeg',
                  'image/png',
                  'application/msword',
                  'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
                  'message/rfc822'
                ]"
                (chooseFiles)="handleFileInput($event)"
                (removeFiles)="clearSelectedFiles($event)"></app-multiple-file-selector>
              <div id="images-show"></div>
            </div>
            <div class="col-12 d-flex justify-content-end acvtypglastbtn">
              <button type="button" class="btn-actvtytp" (click)="saveAndExit()">SAVE & EXIT</button>
              <button type="button" class="btn-discard" (click)="exit()">EXIT</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>
<div *ngIf="showImport || showUpdateImport">
  <app-bulk-import
    [showNavBar]="false"
    [showLeftMenu]="false"
    [validator]="showImport ? importValidator : updateImportValidator"
    (importClose)="showImport = false; showUpdateImport = false"
    [close]="false"></app-bulk-import>
</div>
